module.exports = __webpack_public_path__ + "img/rebond-expertise.16bb6f67.jpg";